import {Locale} from './locale';

export const getAyOutletUrlByLocale = (locale: Locale) => {
  const ayOutleftUrlByLocale: {[K in Locale]?: string} = {
    [Locale.de_DE]: 'https://aboutyou-outlet.de',
    [Locale.en_DE]: 'https://aboutyou-outlet.de',
    [Locale.de_AT]: 'https://aboutyou-outlet.at',
    [Locale.en_AT]: 'https://aboutyou-outlet.at',
    [Locale.cs_CZ]: 'https://aboutyou-outlet.cz',
    [Locale.ro_RO]: 'https://aboutyou-outlet.ro',
    [Locale.hu_HU]: 'https://aboutyou-outlet.hu',
    [Locale.sl_SI]: 'https://aboutyou-outlet.si',
    [Locale.sk_SK]: 'https://aboutyou-outlet.sk',
    [Locale.hr_HR]: 'https://aboutyou-outlet.hr',
    [Locale.pl_PL]: 'https://aboutyou-outlet.pl',
    [Locale.bg_BG]: 'https://aboutyou-outlet.bg',
    [Locale.el_GR]: 'https://aboutyou-outlet.gr',
    [Locale.lt_LT]: 'https://aboutyou-outlet.lt',
    [Locale.lv_LV]: 'https://aboutyou-outlet.lv',
    [Locale.ru_LV]: 'https://aboutyou-outlet.lv',
    [Locale.de_CH]: 'https://aboutyou-outlet.ch',
    [Locale.en_CH]: 'https://aboutyou-outlet.ch',
    [Locale.fr_CH]: 'https://aboutyou-outlet.ch',
    [Locale.it_CH]: 'https://aboutyou-outlet.ch',
    [Locale.nl_NL]: 'https://aboutyou-outlet.nl',
    [Locale.en_NL]: 'https://aboutyou-outlet.nl',
    [Locale.pt_PT]: 'https://aboutyou-outlet.pt',
  };

  return ayOutleftUrlByLocale[locale];
};
